// 运行时间线 / 运行详情相关翻译

export const zh = {
  modeLabel: '模式:',
  modeComplex: '复杂模式',
  modeSimple: '简单模式',
  durationLabel: '耗时:',
  artifactTypeLabel: '类型:',
  hitlWaitingApproval: '等待用户审核执行计划',
  runBack: '返回',
  runNotFound: '运行实例不存在或已被删除',
  noEvents: '暂无事件记录',
  payloadEmpty: '此事件无 Payload 数据',
  selectEventHint: '选择事件查看详情',
  // 运行状态（评审 M8：此前轮询状态栏英文硬编码）
  runStatusQueued: '排队中',
  runStatusRunning: '运行中',
  runStatusAwaiting: '待裁决',
  runStatusResuming: '恢复中',
  runStatusCompleted: '已完成',
  runStatusFailed: '失败',
  runStatusCancelled: '已取消',
  runStatusTimedOut: '已超时',
  // —— 自 common.ts 按域迁入 ——
  totalRuns: '总运行数',
  successRate: '成功率',
  hitlCount: '待审核',
  avgDuration: '平均耗时',
  trends: '趋势',
  days: '天',
  noRuns: '暂无运行记录',
  noRunsHint: '完成第一个任务后，这里会展示你的运行趋势和消耗',
  todayTokens: '今日 Token',
  quotaRemaining: '配额剩余',
  runList: '运行记录',
  prev: '上一页',
  next: '下一页',
}

export const en = {
  modeLabel: 'Mode:',
  modeComplex: 'Complex Mode',
  modeSimple: 'Simple Mode',
  durationLabel: 'Duration:',
  artifactTypeLabel: 'Type:',
  hitlWaitingApproval: 'Waiting for user to review the plan',
  runBack: 'Back',
  runNotFound: 'Run not found or has been deleted',
  noEvents: 'No events yet',
  payloadEmpty: 'No payload data for this event',
  selectEventHint: 'Select an event to view details',
  runStatusQueued: 'Queued',
  runStatusRunning: 'Running',
  runStatusAwaiting: 'Awaiting Review',
  runStatusResuming: 'Resuming',
  runStatusCompleted: 'Completed',
  runStatusFailed: 'Failed',
  runStatusCancelled: 'Cancelled',
  runStatusTimedOut: 'Timed Out',
  // —— 自 common.ts 按域迁入 ——
  totalRuns: 'Total Runs',
  successRate: 'Success Rate',
  hitlCount: 'Awaiting review',
  avgDuration: 'Avg Duration',
  trends: 'Trends',
  days: 'days',
  noRuns: 'No runs yet',
  noRunsHint: 'Your run trends and usage appear here after your first task',
  todayTokens: 'Tokens Today',
  quotaRemaining: 'Quota left',
  runList: 'Run History',
  prev: 'Prev',
  next: 'Next',
}

export const ja = {
  modeLabel: 'モード:',
  modeComplex: '複雑モード',
  modeSimple: 'シンプルモード',
  durationLabel: '所要時間:',
  artifactTypeLabel: 'タイプ:',
  hitlWaitingApproval: 'ユーザーによるプラン確認待ち',
  runBack: '戻る',
  runNotFound: '実行が存在しないか削除されました',
  noEvents: 'イベント記録はありません',
  payloadEmpty: 'このイベントにはPayloadデータがありません',
  selectEventHint: 'イベントを選択して詳細を表示',
  runStatusQueued: '待機中',
  runStatusRunning: '実行中',
  runStatusAwaiting: '承認待ち',
  runStatusResuming: '再開中',
  runStatusCompleted: '完了',
  runStatusFailed: '失敗',
  runStatusCancelled: 'キャンセル済み',
  runStatusTimedOut: 'タイムアウト',
  // —— 自 common.ts 按域迁入 ——
  totalRuns: '総実行数',
  successRate: '成功率',
  hitlCount: '承認待ち',
  avgDuration: '平均所要時間',
  trends: '傾向',
  days: '日',
  noRuns: '実行記録なし',
  noRunsHint: '最初のタスク完了後、ここに実行トレンドと消費量が表示されます',
  todayTokens: '今日のトークン',
  quotaRemaining: '残り枠',
  runList: '実行履歴',
  prev: '前へ',
  next: '次へ',
}
